/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../../../components/ListTitle'
import Datagrid from '../../../../components/Datagrid/Datagrid'
import Filter from '../../../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function FormTypesList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Form Types" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/SS_FormTypeTAB"
                        />
                    ) : (
                        <EditButton basePath="/SS_FormTypeTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

FormTypesList.defaultProps = {
    quickSearch: false,
}
FormTypesList.propTypes = {
    quickSearch: PropTypes.bool,
}
